import { defineStore } from 'pinia'
import { computed, type Ref, ref, watch } from 'vue'
import { useLoadInventObjectType } from '@/entities/Inventory/ObjectTypes'
import type { ObjectTypesEdgesType } from '@/entities/Inventory/ObjectTypesEdges'

export const useTypesEdgesModel = defineStore('types_edges', () => {
  const item = ref<ObjectTypesEdgesType | null>(null)
  const objectTypeData = ref<any>([])
  const open = ref(false)

  /* Следим за модальным окно и сбрасываем данные */
  watch(open, () => {
    if (!open.value) {
      item.value = null
    }
  })

  /**
   * Подгружаем данные по типу
   * @param objectId
   */
  const loadType = (objectId: Ref<string>) => {
    const fromTypeId = computed(() => item.value?.from_type_id || 0)
    const result = useLoadInventObjectType(fromTypeId, objectId)

    watch(result.data, () => {
      if (result.data.value) {
        objectTypeData.value = result.data.value.data.fields
      }
    })

    return result
  }

  return {
    item,
    open,
    objectTypeData,

    loadType,
  }
})
